import { render } from "./content-logs-view-errors-page.vue?vue&type=template&id=07a96dd0"
import script from "./content-logs-view-errors-page.vue?vue&type=script&lang=ts"
export * from "./content-logs-view-errors-page.vue?vue&type=script&lang=ts"

import "./content-logs-view-errors-page.vue?vue&type=style&index=0&id=07a96dd0&lang=less"
script.render = render

export default script